export default __webpack_public_path__ + "static/media/logo.085cbd57.svg";